import { render, staticRenderFns } from "./abandoned-calls.vue?vue&type=template&id=1a03fab1&"
import script from "./abandoned-calls.vue?vue&type=script&lang=js&"
export * from "./abandoned-calls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports